<style>
.center {
  margin: auto;
  width: 60%;
  padding: 10px;
  text-align: right;
}
</style>
<template>
  <div>
    <b-row>
      <b-col>
        <h5>Report List</h5>
        <b-icon-info variant="success"></b-icon-info> &nbsp;Select table row for
        more option.
      </b-col>
      <b-col class="center">
            <b-button-group>
              <DxButton
                id="refreshButton"
                icon="revert"
                hint="Refresh"
                :height="40"
                @click="fillDataTable" />
            </b-button-group>
      </b-col>
    </b-row>

    <div class="overflow-auto">
        <DxDataGrid
          id="daily-report-grid"
          ref="dailyReportGrid"
            :data-source="reportData"
            :show-borders="false"
            :show-column-lines="false"
            :show-row-lines="true"
            column-resize-mode="nextColumn"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :cell-hint-enabled="true"
            :word-wrap-enabled="false"
            :column-auto-width="false"
            date-serialization-format="yyyy-MM-dd"
            :height="300"
            key-expr="submitId"
            @selection-changed="onSelectionChanged"
          >
            <DxPaging :enabled="true" :page-size="5" />
            <DxScrolling mode="standard" />
            <DxSorting mode="single" />
            <DxSelection mode="single"/>
            <DxEditing
              :allow-updating="false"
              :allow-adding="false"
              :allow-deleting="false"
              :use-icons="true"
              mode="form"
            />
            <DxColumn data-type="number" data-field="index" caption="No." sort-order="desc" width="5%">
              <DxFormItem :visible="false"/>
            </DxColumn> 
            <DxColumn data-type="date" data-field="dateReport" caption="Report Date" width="8%"/>
            <DxColumn data-type="datetime" data-field="submittedTime" caption="Submit Time" width="12%">
              <DxFormItem :visible="false"/>
            </DxColumn>
            <DxColumn data-field="wellboreName" caption="Wellbore Name" width="15%"/>
            <DxColumn data-field="wellboreType" caption="Wellbore Type" width="8%">
              <DxLookup
                :data-source="optionWellboreType"
                value-expr="value"
                display-expr="text"
              />
            </DxColumn>
            <DxColumn data-field="rigOps" caption="Rig Ops" width="5%" />
            <DxColumn data-type="number" data-field="rkbHeight" caption="RKB Height" width="8%"/>
            <DxColumn data-type="number" data-field="approvedStatus" caption="Report Status" :allow-sorting="false" :calculate-display-value="getStatusText">
              <DxFormItem :visible="false"/>
            </DxColumn>
            <DxColumn data-field="description" caption="Brief Summary">
              <DxFormItem :col-span="2" :editor-options="{  height: 50 }" editor-type="dxTextArea" />
            </DxColumn>
        </DxDataGrid>
    </div>
    <hr />
    <b-overlay v-if="showDetails" rounded="sm">
      <b-row style="padding-bottom: 10px">
        <b-col>
          <span class="font-weight-bold mx-2">Report no. {{ selectedRow.index }}</span>
          <span v-if="confirmShow"> 
            Are you sure to {{confirmWording}} this report ? 
            <b-button-group>
            <b-button size="sm" variant="success" @click="submitApproval(approveAction)">Yes</b-button>
            <b-button size="sm" variant="danger" @click="no">No</b-button>
            </b-button-group>
          </span>
          <b-button-group v-if="!confirmShow">
            <b-button v-show="!previouslyEdited" size="sm" variant="success" @click="confirm('approve')">Approve</b-button>
            <b-button size="sm" variant="danger" @click="confirm('reject')">Reject</b-button>
            <b-button v-if="!previouslyEdited || (editable && previouslyEdited)" size="sm" variant="info" @click="confirm('edit')"
              >{{editCaption}}</b-button
            >
            <b-button v-if="!editable && previouslyEdited" size="sm" variant="info" @click="revisionApplied"
              >Notify Change</b-button
            >
          </b-button-group>
        </b-col>
      </b-row>
      <div>
        <b-card no-body>
          <b-tabs small>
            <b-tab ref="tabGeneral" title="General" lazy>
              <General
                    :submit-id="submitId"
                    :well-id="wellId"
                    :editable="editable"
                    :report-map="masterReportMap"
                    :daily-report-date="selectedReportDate"
                  />
            </b-tab>
            <b-tab ref="tabOpsSummary" title="Ops. Summary" lazy>
              <OperationSummary
                    :submit-id="submitId"
                    :well-id="wellId"
                    :editable="editable"
                    :report-map="masterReportMap"
                  />
            </b-tab>
            <b-tab ref="tabBit" title="Bit" lazy>
              <Bit
                    :submit-id="submitId"
                    :well-id="wellId"
                    :editable="editable"
                    :report-map="masterReportMap"
                  />
            </b-tab>
            <b-tab ref="tabBha" title="BHA" lazy>
              <WorkString
                    :submit-id="submitId"
                    :well-id="wellId"
                    :editable="editable"
                    :report-map="masterReportMap"
                  />
            </b-tab>
            <b-tab ref="tabCost" title="Field Cost" lazy>
              <Cost
                    :submit-id="submitId"
                    :well-id="wellId"
                    :editable="editable"
                    :report-map="masterReportMap"
                  />
            </b-tab>
            <b-tab ref="tabMaterialUsage" title="Material Usage" lazy>
              <MaterialUsage
                    :submit-id="submitId"
                    :well-id="wellId"
                    :editable="editable"
                    :report-map="masterReportMap"
                  />
            </b-tab>
            <b-tab ref="tabMud" title="Mud" lazy>
              <Mud
                    :submit-id="submitId"
                    :well-id="wellId"
                    :editable="editable"
                    :report-map="masterReportMap"
                  />
            </b-tab>
            <b-tab ref="tabSurvey" title="Survey" lazy>
              <Survey
                    :submit-id="submitId"
                    :well-id="wellId"
                    :editable="editable"
                    :report-map="masterReportMap"
                  />
            </b-tab>
            <b-tab ref="tabHSE" title="HSE" lazy>
              <Hse
                    :submit-id="submitId"
                    :well-id="wellId"
                    :editable="editable"
                    :report-map="masterReportMap"
                  />
            </b-tab>
            <b-tab ref="tabDrillingParameter" title="Drilling Parameters" lazy>
              <DrillingParameters
                    :submit-id="submitId"
                    :well-id="wellId"
                    :editable="editable"
                    :report-map="masterReportMap"
                  />
            </b-tab>
            <b-tab ref="tabDrilledSection" title="Drilled Section" lazy>
              <DrilledSection
                    :submit-id="submitId"
                    :well-id="wellId"
                    :editable="editable"
                    :report-map="masterReportMap"
                  />
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods, formComputed, authComputed } from '@state/helpers'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import axios from 'axios'
import qs from 'querystring'
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxEditing,
  DxLookup,
  DxFormItem,
  DxSelection,
  DxSorting,
  DxPaging,
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import General from '@components/form/daily-drilling-report/general'
import Survey from '@components/form/daily-drilling-report/survey'
import Mud from '@components/form/daily-drilling-report/mud'
import Cost from '@components/form/daily-drilling-report/cost'
import OperationSummary from '@components/form/daily-drilling-report/opsum'
import DrillingParameters from '@components/form/daily-drilling-report/drilling-parameters'
import Bit from '@components/form/daily-drilling-report/bit'
import WorkString from '@components/form/daily-drilling-report/bha'
import Hse from '@components/form/daily-drilling-report/hse'
import MaterialUsage from '@components/form/daily-drilling-report/material-usage'
import DrilledSection from '@/src/components/form/daily-drilling-report/drilled-section.vue' 
import mapApiUrl from '@/src/utils/api-mapper'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.use(VueFormGenerator)

export default {
  components: {
    General,
    Survey,
    Mud,
    Cost,
    OperationSummary,
    DrillingParameters, 
    Bit,
    WorkString,
    Hse,
    MaterialUsage,
    DrilledSection, 
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxLookup,
    DxFormItem,
    DxScrolling,
    DxSelection,
    DxSorting, 
    DxPaging,
    // DxButton
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    wellId: { type: Number, default: undefined },
    padId: { type: Number, default: undefined },
    fieldId: { type: Number, default: undefined },
  },
  data() {
    return {
      currentWell: this.$store.state.auth.currentWell,
      confirmShow: false,
      confirmWording: '',
      approveAction: true,
      perPage: 10,
      submitId: 0,
      showDetails: false,
      currentPage: 1,
      selectedRow: {},
      tableItems: [],
      reportData: [],
      masterReportMap: [],
      editable: false,
      previouslyEdited: false,
      dailyReportIsLoading: false,
      optionWellboreType: [
        { text: "Original Hole", value: "Original Hole" },
        { text: "Sidetrack 1", value: "Sidetrack 1"},
        { text: "Sidetrack 2", value: "Sidetrack 2"},
      ],
      getStatusText(rowData) {
      const statusTexts = ["DRAFT", "WAITING FOR APPROVAL", "APPROVED", "REJECTED", "APPROVED WITH EDIT"]
      return statusTexts[rowData.approvedStatus - 1]
    },
      editStatus: false,
      editCaption: 'Edit',
      btnVarian: 'outline-primary',
      fields: [
        { key: 'submitId', label: 'Report No.', sortable: true },
        { key: 'wellName', label: 'Well Name', sortable: true },
        { key: 'wellboreName', label: 'Wellbore Name', sortable: true },
        { key: 'dateReport', label: 'Report Date', sortable: true },
        { key: 'fullName', label: 'Submitted By', sortable: true },
        { key: 'submittedTime', label: 'Submitted Time', sortable: true },
        { key: 'approvedStatus', label: 'Status', sortable: true },
      ],
    }
  },
  computed: {
    ...formComputed,
    ...authComputed,
    totalRow: function () {
      let cnt = this.tableItems ? this.tableItems.length : 0
      // inform to parent
      this.totalRowDdr(cnt)
      // return to row count of table
      return cnt
    },
  },
  watch: {
    wellId: function (val) {
      this.fillDataTable()
    },
    padId: function (val) {
      this.fillDataTable()
    },
    fieldId: function (val) {
      this.fillDataTable()
    },
    editable: function(val) {
      this.previouslyEdited = this.previouslyEdited || val
      if (val) {
        this.editCaption = 'Stop Edit'
        this.btnVarian = 'outline-danger'
      } else {
        this.editCaption = 'Edit'
        this.btnVarian = 'outline-primary'
      }
    }
  },
  created() {
    this.fillDataTable()
  },
  methods: {
    ...formMethods,
    no() {
      this.confirmShow = false
    },
    confirm(val){
      if (val === 'edit' && this.editable) this.editable = false
      else this.confirmShow = true
      this.confirmWording = val
      this.approveAction = val // === 'edit' ? 'edit' : val === 'approve'
    },
    revisionApplied() {
      const newStatus = this.formStatus(5)
      const url = mapApiUrl('/api/form/master/approval')
          let param = { submitId: this.submitId, newApproval: newStatus}
          axios.post(url, qs.stringify(param)).then((response) => {
            notify({ message: 'New approval status has been applied.', width: 500 }, 'success', 3000)
            this.$refs.dailyReportGrid.instance.clearSelection()
            this.fillDataTable()
          })
    },
    onSelectionChanged(e) {
      this.selectedRow = e.selectedRowsData[0]
      window.localStorage.setItem('submitId', this.selectedRow.submitId)
      window.localStorage.setItem('reportNo', this.selectedRow.index)
      this.submitId = this.selectedRow.submitId
      this.selectedReportDate = this.selectedRow.reportDate
      this.showDetails = true
    },
    onRowSelected(items) {
      if (items.length > 0) {
        this.showDetails = true
        this.selectedRow = items[0]
        this.submitId = this.selectedRow.submitId
      } else {
        this.showDetails = false
        this.selectedRow = []
        this.submitId = 0
      }
      this.editable = false
      this.previouslyEdited = false
      this.confirmShow = false
    },
    fillDataTable() {
      this.reportData = []
      this.dailyReportIsLoading = true
      const url = mapApiUrl('/api/form/master/list-waiting-approval')
      let params={wellId: this.wellId}
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
        this.dailyReportIsLoading = false
        this.confirmShow = false
        this.showDetails = false
        this.reportData = response.data
        if (this.reportData === undefined) return
        if (this.reportData.length === 0) return
        // sort data by report date descendingly
        this.reportData.sort((a,b) => { return Date.parse(b.reportDate) - Date.parse(a.reportDate) })
        this.masterReportMap = []
        this.reportData.forEach((item, index) => {
          item.index = index + 1
          item.createdAt=item.submittedTime.substr(0,19)
          this.masterReportMap.push({index: item.index, submitId: item.id})
        })
      })
    },
    submitApproval(response) {
      if (this.confirmWording === 'edit') {
        this.editable = true
        this.confirmShow = false
        this.previouslyEdited = false
      } else {
        const newStatus = this.confirmWording === 'reject' ? this.formStatus(4) : this.formStatus(3)
        if (response) {
          const url = mapApiUrl('/api/form/master/approval')
          let param = { submitId: this.submitId, newApproval: newStatus} // 'APPROVED & ACKNOWLEDGED'}
          axios.post(url, qs.stringify(param)).then((response) => {
            notify({ message: 'New approval status has been applied.', width: 500 }, 'success', 3000)
            this.$refs.dailyReportGrid.instance.clearSelection()
            this.fillDataTable()
          })
        }
      }
    },
    toggleEdit() {
      this.editStatus = !this.editStatus
      if (this.editStatus) {
        this.editCaption = 'Stop Edit'
        this.btnVarian = 'outline-danger'
      } else {
        this.editCaption = 'Edit'
        this.btnVarian = 'outline-primary'
      }
    },
    formStatus(code) {
      let statusReturn = code
      switch (code) {
        case 1:
          statusReturn = 'DRAFT'
          break
        case 2:
          statusReturn = 'WAITING FOR APPROVAL'
          break
        case 3:
          statusReturn = 'APPROVED'
          break
        case 4:
          statusReturn = 'REJECTED'
          break
        case 5:
          statusReturn = 'APPROVED WITH EDIT'
          break
        default:
          return code
      }
      return statusReturn
    },
  },
}
</script>